export const randomNum = function(minNum, maxNum) {
    const fixed=1;
    switch (arguments.length) {
        case 1:
            return (Math.random() * minNum + 1).toFixed(fixed);
        case 2:
            return (Math.random() * (maxNum - minNum + 1) + minNum).toFixed(fixed);
        default:
            return 0;
    }
};
export const AREA = ['Uttar Pradesh','Mumbai','Delhel','Rajasthan'] 
export const randomKM = () => {
    return randomNum(7,40)
}
export const randomArea = () => {
    const areas = AREA
    const index=Math.floor(randomNum(0,areas.length-1))
    return areas[index]
}
export const randomView = () => {
    const view=randomNum(300,1000)
    return view
}